import { RouterConfig } from '@angular/router';
import { GrowthRatesComponent } from './growth-rates.component';
import { GrowthRatesSaveComponent } from './growth-rates-save/growth-rates-save.component';
import {SetHubSizesComponent} from './set-hub-sizes/set-hub-sizes.component';

export const GrowthRatesRoutes: RouterConfig = [
  //all Growthrates routes here
  {path: 'growth-rates', component: GrowthRatesComponent},
  {path: 'growth-rates-save', component: GrowthRatesSaveComponent},
  {path: 'set-hub-sizes', component: SetHubSizesComponent},
];





/** WEBPACK FOOTER **
 ** ./app/system-management/growth-rates/growth-rates.routes.ts
 **/